import { ApiCore } from "./utilities/core";

export const tenantAPI = () => {
  return new ApiCore({
    getAll: true,
    getSingle: true,
    post: true,
    put: true,
    remove: true,
    url: `api/tenant`,
  });
};
